// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExqNPmmOBtMtwfDN {
	padding: var(--lok-spacing-7);
}

.UhlGvcIxx2MyyETx {
	flex: 1;
}

.H8tfBMDoERppf4yK {
	font: var(--lok-typography-body-small-strong);
	font-family: var(--lok-font-family-inter);
}

.o9nNFUXCb6gtti7v > button {
	width: 100%;
}

.HkWvh75tEBYQgDRc {
	font: var(--lok-typography-heading-3);
	font-family: var(--lok-font-family-inter);
}

.kY6g9tMzcf4KCDL0 {
	font: var(--lok-typography-body-small-default);
	font-family: var(--lok-font-family-inter);
}

.P3_3eYFZrL8zkFqr {
	height: 100%;
}

.ixp0TB9cNzgVPO9y {
	width: 470px;
	min-height: 538px;
}

.kC1q64Qhbzk7_sJD.kC1q64Qhbzk7_sJD {
	max-width: 400px;
	text-align: center;
	font-family: var(--lok-font-family-inter);
}

.UOq0xtbLRCc0QYj9 {
	display: flex;
	align-items: center;
	gap: var(--lok-spacing-1);

	color: var(--lok-color-text-warning);
	font: var(--lok-typography-body-tiny-default);
	font-family: var(--lok-font-family-inter);

	> span {
		flex: 1;
	}
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/AssignmentModal/components/TMDataSourceStep/TMDataSourceStep.module.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,OAAO;AACR;;AAEA;CACC,6CAA6C;CAC7C,yCAAyC;AAC1C;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,qCAAqC;CACrC,yCAAyC;AAC1C;;AAEA;CACC,8CAA8C;CAC9C,yCAAyC;AAC1C;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,yCAAyC;AAC1C;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,yBAAyB;;CAEzB,oCAAoC;CACpC,6CAA6C;CAC7C,yCAAyC;;CAEzC;EACC,OAAO;CACR;AACD","sourcesContent":[".container {\n\tpadding: var(--lok-spacing-7);\n}\n\n.contents {\n\tflex: 1;\n}\n\n.controlLabel {\n\tfont: var(--lok-typography-body-small-strong);\n\tfont-family: var(--lok-font-family-inter);\n}\n\n.dateControl > button {\n\twidth: 100%;\n}\n\n.heading {\n\tfont: var(--lok-typography-heading-3);\n\tfont-family: var(--lok-font-family-inter);\n}\n\n.subheading {\n\tfont: var(--lok-typography-body-small-default);\n\tfont-family: var(--lok-font-family-inter);\n}\n\n.footer {\n\theight: 100%;\n}\n\n.imageContainer {\n\twidth: 470px;\n\tmin-height: 538px;\n}\n\n.tooltip.tooltip {\n\tmax-width: 400px;\n\ttext-align: center;\n\tfont-family: var(--lok-font-family-inter);\n}\n\n.warning {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: var(--lok-spacing-1);\n\n\tcolor: var(--lok-color-text-warning);\n\tfont: var(--lok-typography-body-tiny-default);\n\tfont-family: var(--lok-font-family-inter);\n\n\t> span {\n\t\tflex: 1;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ExqNPmmOBtMtwfDN`,
	"contents": `UhlGvcIxx2MyyETx`,
	"controlLabel": `H8tfBMDoERppf4yK`,
	"dateControl": `o9nNFUXCb6gtti7v`,
	"heading": `HkWvh75tEBYQgDRc`,
	"subheading": `kY6g9tMzcf4KCDL0`,
	"footer": `P3_3eYFZrL8zkFqr`,
	"imageContainer": `ixp0TB9cNzgVPO9y`,
	"tooltip": `kC1q64Qhbzk7_sJD`,
	"warning": `UOq0xtbLRCc0QYj9`
};
export default ___CSS_LOADER_EXPORT___;
